var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1833_3795",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1833_3795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.80523 13.2667C3.50512 13.2667 3.25145 13.1631 3.04423 12.9559C2.83701 12.7487 2.7334 12.495 2.7334 12.1949V3.80523C2.7334 3.50512 2.83701 3.25145 3.04423 3.04423C3.25145 2.83701 3.50512 2.7334 3.80523 2.7334H7.74357V3.60007H3.80523C3.7539 3.60007 3.7069 3.62145 3.66423 3.66423C3.62145 3.7069 3.60007 3.7539 3.60007 3.80523V12.1949C3.60007 12.2462 3.62145 12.2932 3.66423 12.3359C3.7069 12.3787 3.7539 12.4001 3.80523 12.4001H12.1949C12.2462 12.4001 12.2932 12.3787 12.3359 12.3359C12.3787 12.2932 12.4001 12.2462 12.4001 12.1949V8.25657H13.2667V12.1949C13.2667 12.495 13.1631 12.7487 12.9559 12.9559C12.7487 13.1631 12.495 13.2667 12.1949 13.2667H3.80523ZM6.4629 10.1564L5.84373 9.53723L11.7809 3.60007H9.60007V2.7334H13.2667V6.40007H12.4001V4.21923L6.4629 10.1564Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/open-icon.1dd3ebf7ba4fdd46901fafa095b53e0f.svg";
export { ForwardRef as ReactComponent };